import { action, observable, makeObservable } from 'mobx';
import { createTransformer } from 'mobx-utils';

import { EntityList } from '@vromo/models';
import { Role } from '@vromo/models';

export default class RoleStore {
    roles: EntityList<Role> = new EntityList(Role);
    loaded = false;

    withId = createTransformer((role: number) => this.roles.find((r) => r.user.id === role));

    withGroup = createTransformer((group: number) =>
        this.roles.filter((r) => r.account?.id === group)
    );

    constructor() {
        makeObservable(this, {
            roles: observable,
            loaded: observable
        });
    }
}
